import ShippingQuote from './ShippingQuote';

export default ShippingQuote;
